import React, {useContext, useState} from "react";
import { languageContext } from "../../../config/language";

// styled components
import {
  DateRangeFilterContainer,
  ExternalFilterContainer,
} from "./Filters.styles";

// components
import DateRangePicker from "../../Common/DateRangePicker";

// types
import {DateRange} from "../../../types/common";
import {getMinMaxDate} from "../../../utils/functions";

interface Props {
  rangeDate: DateRange;
  setRangeDate: (rangeDate: DateRange) => void;
}

const DateFilters = (props: Props) => {
  const { languageContext: lang } = useContext(languageContext);

  const initialDateLimits = getMinMaxDate(new Date(), 180);
  const [minDate, setMinDate] = useState<Date>(initialDateLimits.min);
  const [maxDate, setMaxDate] = useState<Date>(initialDateLimits.max);

  const handleChangeDateRange = (event: any) => {
    const { value } = event.target;
    const { start } = value;

    const dateLimits = getMinMaxDate(start, 180);
    setMinDate(dateLimits.min);
    setMaxDate(dateLimits.max);

    props.setRangeDate(value);
  };

  return (
    <div className="row">
      <ExternalFilterContainer className="col-lg-12 col-md-12 col-sm-12">
        <DateRangeFilterContainer>
          <DateRangePicker
            dateRange={props.rangeDate}
            handleChange={handleChangeDateRange}
            startLabel={lang.dateFrom}
            endLabel={lang.dateTo}
            format="dd/MMM/yyyy"
            minDate={minDate}
            maxDate={maxDate}
          />
        </DateRangeFilterContainer>
      </ExternalFilterContainer>
    </div>
  );
};

export default DateFilters;
